<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                            :withPagination=false
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity" :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter" :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesPrdSubstationPowerRecordResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="openCreateDialog()"
                                    >
                                        创建输入项
                                    </b-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="创建输入项" :visible.sync="createDialogVisible" :close-on-click-modal='false' append-to-body @close='clearCreateForm'>
            <el-form :model="createForm" ref="createForm" label-width="auto" width="30%" :inline="true" :rules="rules">
                <el-form-item label="记录时间" prop="requiredTime">
                    <el-date-picker v-model="createForm.recordTime" type="datetime" placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="createBasicRecords()">创建</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-11-04 10:51:28

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import emCommonApiMixin from "@/mixin/em/common/api";

    export default {
        name: "mintalMesPrdSubstationPowerRecordListView",
        mixins: [emCommonListMixin,emCustomVuexMixin,emCommonApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                createDialogVisible: false,
                createForm: {
                    recordTime: ''
                },
                rules: {
                    recordTime: [{required: true, message: '请选择日期时间'}],
                },
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        },
        methods: {
            openCreateDialog() {
                this.createDialogVisible = true;
            },
            clearCreateForm() {
                this.createForm.recordTime = '';
                this.$refs["createForm"].resetFields();
            },
            createBasicRecords() {
                let self = this;
                self.$refs["createForm"].validate(valid => {
                    if(valid) {
                        let url = `${this.$_emApiMixin_entityBaseApi("mintalMesPrdSubstationPowerRecord")}/createBasicRecords?recordTime=${self.createForm.recordTime}`;
                        self.$_emApiMixin_post(url, {})
                            .then((request) => {
                                if (request.status === 200) {
                                    self.$message({
                                        message: "创建成功",
                                        type: "success",
                                    });

                                } else {
                                    self.$message({
                                        message: "创建失败",
                                        type: "error",
                                    });
                                }
                            }).finally(() => {
                            this.createDialogVisible = false;
                        })
                    } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
                })
            }
        }
    };
</script>
